module.exports = __webpack_public_path__ + "static/media/restaurant_icon.d19058b9.svg";